import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import Login from "@/components/Login";
import CommandCenter from "@/components/CommandCenter";
import Personnel from "@/components/Personnel";
import ChainOfCommand from "@/components/ChainOfCommand";
import AuditLogs from "@/components/AuditLogs";
import Training from "@/components/Training";
import Deployments from "@/components/Deployments";
import Finance from "@/components/Finance";
import Disciplinary from "@/components/Disciplinary";
import Promotions from "@/components/Promotions";
import Communications from "@/components/Communications";
import AdminPanel from "@/components/AdminPanel";
import Layout from "@/components/Layout";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Axios interceptor for auth token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await axios.get(`${API}/auth/me`);
        setUser(response.data);
      } catch (error) {
        console.error('Auth check failed:', error);
        localStorage.removeItem('token');
      }
    }
    setLoading(false);
  };

  const handleLogin = (userData, token) => {
    localStorage.setItem('token', token);
    // Fetch full user data including session info
    checkAuth();
  };

  const handleLogout = async () => {
    try {
      await axios.post(`${API}/auth/logout`);
    } catch (error) {
      console.error('Logout failed:', error);
    }
    localStorage.removeItem('token');
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--color-navy-900)' }}>
        <div className="text-center">
          <div className="spinner mx-auto mb-4"></div>
          <p className="text-white text-lg">Loading Guardian | AEGIS...</p>
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={!user ? <Login onLogin={handleLogin} /> : <Navigate to="/" />}
        />
        <Route
          path="/"
          element={
            user ? (
              <Layout user={user} onLogout={handleLogout}>
                <CommandCenter user={user} />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/personnel"
          element={
            user ? (
              <Layout user={user} onLogout={handleLogout}>
                <Personnel user={user} />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/promotions"
          element={
            user ? (
              <Layout user={user} onLogout={handleLogout}>
                <Promotions user={user} />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/training"
          element={
            user ? (
              <Layout user={user} onLogout={handleLogout}>
                <Training user={user} />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/deployments"
          element={
            user ? (
              <Layout user={user} onLogout={handleLogout}>
                <Deployments user={user} />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/finance"
          element={
            user ? (
              <Layout user={user} onLogout={handleLogout}>
                <Finance user={user} />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/disciplinary"
          element={
            user ? (
              <Layout user={user} onLogout={handleLogout}>
                <Disciplinary user={user} />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/chain-of-command"
          element={
            user ? (
              <Layout user={user} onLogout={handleLogout}>
                <ChainOfCommand user={user} />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/audit-logs"
          element={
            user ? (
              <Layout user={user} onLogout={handleLogout}>
                <AuditLogs user={user} />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/communications"
          element={
            user ? (
              <Layout user={user} onLogout={handleLogout}>
                <Communications user={user} />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/admin"
          element={
            user ? (
              <Layout user={user} onLogout={handleLogout}>
                <AdminPanel user={user} />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
